<!--
  This cannot be a mp-entity-list,
  since projection messes up the cdkDropList:
-->

@if (kataloge.length > 0) {
  <div cdkDropList (cdkDropListDropped)="handleItemDropped($event)">
    @for (katalog of kataloge; track katalog.catalogId) {
      <mp-sortable-catalog
        class="sortable-catalog-item"
        cdkDrag
        cdkDragLockAxis="y"
        [cdkDragDisabled]="!allowSort"
        [catalog]="katalog"
        [allowWrite]="allowWrite"
        [allowNavigation]="allowNavigation()"
        [focus]="(lastSortedId$ | async) === katalog.catalogId"
        (itemUpdated)="handleItemAktualisiert($event)"
        (itemRemoved)="emitItemRemoved(katalog)"
        (industryCatalogClicked)="emitIndustriekatalogClicked($event)"
      >
        @if (allowSort && allowWrite) {
          <mp-drag-handle
            showIndexInput
            [minIndex]="1"
            [maxIndex]="maxIndex"
            [index]="katalog.order"
            [invertArrowKeys]="invertArrowKeys"
            (itemReorder)="handleItemSortedManually(katalog, $event)"
          >
            <mat-icon cdkDragHandle>drag_indicator</mat-icon>
          </mp-drag-handle>
        }

        <mp-catalog-drag-placeholder *cdkDragPlaceholder />
      </mp-sortable-catalog>
    }
  </div>
} @else {
  <div class="list-placeholder"></div>
}
